const documentation = (axios) => {
  return {

    /**
     * @param params
     * @method post
     * @api /api/docs
     */
    get(params) {
      return axios.post('/docs', params)
        .then((response) => response);
    },
    // THIS METHOD DOES NoT USED
    // /**
    //  * @param params
    //  * @method post
    //  * @api /api/docs
    //  */
    // add(params) {
    //     return axios.post(`/docs`)
    //         .then(response => response);
    // },

    /**
     * @param params
     * @method post
     * @api /api/docs/update
     */
    update(params) {
      return axios.post('/docs/update', params)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/docs/upload
     */
    upload(params) {
      return axios.post('/docs/upload', params)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/docs/delete/{id}
     */
    remove(id) {
      return axios.post(`/docs/delete/${id}`)
        .then((response) => response);
    },

    fileDownload(guid) {
      return axios({
        url: `/docs/download/${guid}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => response);
    },

    fileView(link) {
      return axios({
        url: `/docs/download/${link}`,
        responseType: 'blob',
      }).then((response) => response);
    },

    filePrint(link) {
      return axios({
        url: `/docs/download/${link}`,
        responseType: 'blob',
      }).then((response) => response);
    },
  };
};

export default documentation;
